import React, { useState, useEffect } from 'react';
import { Card, Notification } from "rbx";
import PdvService from '../../../services/pdv';
import Controls from '../../components/Controls/Controls';

const PdvActivateForm = ({ setMessage, goToMenu }) => {
  const pdv = JSON.parse(sessionStorage.getItem('pdv'));
  const [pdvCode, setPdvCode] = useState('')
  const [status, setStatus] = useState('');
  const [stateButton, setStateButton] = useState('');

  useEffect(() => {
    if (!pdv.isPendingActivation) {
      setMessage(['warning', 'Este PDV já foi ativado!']);
      goToMenu();
    }
  },[])

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    try {
      const response = await PdvService.activate({cpf_cnpj: pdv.cpf_cnpj, pdvCode: pdvCode});
      await PdvService.findByCpf(pdv.cpf_cnpj);
      setMessage(['success', `${response.status}: ${response.data.message}`]);
      goToMenu();
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e}`]);
    }
    setStateButton('');
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>Ativar PDV</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Controls.TextField 
            label="Informe o Código de Ativação"
            name="pdvCode"
            placeholder='1234'
            value={pdvCode}
            onChange={e => setPdvCode(e.target.value)}
            required
            focus={true}
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Ativar'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default PdvActivateForm;
